import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Get all assets
   * @returns an observable
   */
    getAll() {
      return this.http.get<any>( `${environment.baseUrl}/asset/all` );
    }

    /**
     * Get an especific asset
     * @param id {Integer} - Asset's unique id
     * @returns an observable
     */
    get( id: Number ) {
      return this.http.get<any>( `${environment.baseUrl}/asset/${ id }` );
    }

    checkUserParticipation( userAddress: string, assetId: Number ) {
      return this.http.get<any>( `${environment.baseUrl}/asset/user-participation${ userAddress }/${ assetId }` );
    }

    /**
     * Get info about the sale of an asset ( if it's on sale )
     * @param poolAddress {String} - Asset's pool address
     * @returns an observable
     */
    getSaleInfo( poolAddress: string ) {
      return this.http.get<any>( `${environment.baseUrl}/asset/sale-info/${ poolAddress }` );
    }

    /**
     * Get all the purchases history of an asset
     * @param poolAddress {String} - Asset's pool address
     * @returns an observable
     */
    getPurchasesHistory( poolTokenAddress: string ) {
      return this.http.get<any>( `${environment.baseUrl}/asset/purchases-history/${ poolTokenAddress }` );
    }

    /**
     * Get the price history of an especific asset
     * @param poolTokenAddress {String} - Asset's pool token address
     * @returns an observable
     */
    getPriceHistory( poolTokenAddress: string ) {
      return this.http.get<any>( `${environment.baseUrl}/asset/price-history/${ poolTokenAddress }` );
    }

    getCollectionAssetsPriceHistory( collectionId: number) {
      return this.http.get<any>( `${environment.baseUrl}/asset/collection-price-history/${ collectionId }` );
    }

    /**
     * Add a new user to an existing asset
     * @param assetId {Number} - Asset's unique id
     * @param userAddress {String} - User's address
     * @returns an observable
     */
    addUserToAsset( assetId: Number, userAddress: string ) {
      return this.http.post<any>( `${environment.baseUrl}/asset/add-user/${ assetId }/${ userAddress }`, {} );
    }

    /**
     * Create a new asset
     * @param assetObj {Object} - Asset object to create
     * @returns an observable
     */
    create( assetObj: object ) {
      return this.http.post<any>( `${environment.baseUrl}/asset/`, assetObj )
    }

    /**
     * Delete an existing asset
     * @param id {Integer} - Asset's unique id
     * @returns an observable
     */
    delete( id: Number ) {
      return this.http.delete<any>( `${environment.baseUrl}/asset/delete/${ id }` );
    }

    /**
     * Update an existing asset
     * @param id {Number} - Asset's unique id
     * @param assetObj {Object} - Asset object to update
     * @returns an observable
     */
    update( id: Number, assetObj: object ) {
      return this.http.patch<any>( `${environment.baseUrl}/asset/update/${ id }`, assetObj );
    }
}
